import { render, staticRenderFns } from "./Contratar.vue?vue&type=template&id=45e2fbc6"
import script from "./Contratar.vue?vue&type=script&lang=js"
export * from "./Contratar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports